import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Invoice } from './invoice.entity';
import { InvoiceStatus } from './invoice.status.enum';

export class CreateInvoiceDto extends Omit(Invoice, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: InvoiceStatus;
    metadata?: { [key: string]: string }; // This field is required to satisfy TypeScript's structural typing. Without it, TypeScript raises an error because the 'metadata' property is expected in certain contexts where CreateInvoiceDto is used.
}
